<template>
    <div class="row budget-list">
        <div class="col-3 pr-0">
            <table class="categories-table">
                <thead>
                    <tr>
                        <th><span class="empty-item"></span></th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class="plan-category">
                            <b>Доход</b>
                        </td>
                    </tr>
                    <!-- <tr :class="`category-hover category-income-${category.id}`" v-for="category in incomesCategories" :key="category.id" :data-category-id="category.id">
                        <td class="plan-category text-no-wrap overflow-hidden">
                            <span>{{ category.name }}</span>
                        </td>
                    </tr> -->
                    <tr>
                        <td class="pt-5 plan-category">
                            <b>Расход</b>
                        </td>
                    </tr>
                    <tr :class="`category-hover category-outcome-${category.id}`" v-for="category in outcomesCategories" :key="category.id" :data-category-id="category.id">
                        <td class="plan-category text-no-wrap overflow-hidden">
                            <span>{{ category.name }}</span>
                        </td>
                    </tr>
                    <tr>
                        <td class="plan-category pt-5"><b>Остаток</b></td>
                    </tr>
                    <!-- <tr>
                        <td class="plan-category "><b>Баланс</b></td>
                    </tr> -->
                </tbody>
            </table>
        </div>
        <div class="col-9 border-left pl-0">
            <div class="plan-wrap">
                <div class="data-wrap">
                    <table class="table-borderless past-table">
                        <thead class="moving-head">
                            <tr>
                                <template v-for="(month, index) in past">
                                    <th class="month-name" colspan="2" v-text="month.name" :key="`past-month-name-${index}`"></th>
                                </template>
                                <th class="month-name current" v-text="current.name"></th>
                                <th class="month-name current text-right">
                                    <router-link :to="`/budget/${budget.id}/month/${current.date}`"><i class="fas fa-edit"></i></router-link>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <template v-for="(month, index) in past">
                                    <td class="value summary" :key="`past-planned-income-value-summary-${index}`">
                                        <b>{{ month.income.planned.amount | money }}</b>
                                    </td>
                                    <td class="value summary" :key="`past-fact-income-value-summary-${index}`">
                                        <b>{{ month.income.fact.amount | money }}</b>
                                    </td>
                                </template>
                                <td class="value summary current">
                                    <b>{{ current.income.planned.amount | money }}</b>
                                </td>
                                <td class="value summary current">
                                    <b>{{ current.income.fact.amount | money }}</b>
                                </td>
                            </tr>
                            <tr>
                                <template v-for="(month, index) in past">
                                    <td class="pt-5 value summary" :key="`past-planned-outcome-value-summary-${index}`">
                                        <b>{{ month.outcome.planned.amount | money }}</b>
                                    </td>
                                    <td class="pt-5 value summary" :key="`past-fact-outcome-value-summary-${index}`">
                                        <b>{{ month.outcome.fact.amount | money }}</b>
                                    </td>
                                </template>
                                <td class="pt-5 value summary current">
                                    <b>{{ current.outcome.planned.amount | money }}</b>
                                </td>
                                <td class="pt-5 value summary current">
                                    <b>{{ current.outcome.fact.amount | money }}</b>
                                </td>
                            </tr>
                            <tr :class="`category-hover category-outcome-${category.id}`" v-for="category in categories" :key="`past-outcome-${category.id}`" :data-category-id="category.id">
                                <template v-for="(month, index) in past">
                                    <td class="value" :key="`past-planned-outcome-category-value-${category.id}-${index}`">
                                        <span>{{ getCategoryValue(month.outcome.planned.categories, category.id) | money }}</span>
                                    </td>
                                    <td class="value" :key="`past-fact-outcome-category-value-${category.id}-${index}`">
                                        <span>{{ getCategoryValue(month.outcome.fact.categories, category.id) | money }}</span>
                                    </td>
                                </template>

                                <td class="value current">
                                    <span>{{ getCategoryValue(current.outcome.planned.categories, category.id) | money }}</span>
                                </td>
                                <td class="value current">
                                    <span>{{ getCategoryValue(current.outcome.fact.categories, category.id) | money }}</span>
                                </td>
                            </tr>
                            <tr>
                                <template v-for="(month, index) in past">
                                    <td class="pt-5 value summary" :key="`past-planned-diff-value-summary-${index}`">
                                        <b>{{ (month.income.planned.amount - month.outcome.planned.amount) | money }}</b>
                                    </td>
                                    <td :class="{'pt-5 value summary summary': true, 'text-danger': (month.income.fact.amount - month.outcome.fact.amount) < 0}" :key="`past-fact-diff-value-summary-${index}`">
                                        <b>{{ (month.income.fact.amount - month.outcome.fact.amount) | money }}</b>
                                    </td>
                                </template>

                                <td class="pt-5 value summary current">
                                    <b>{{ (current.income.planned.amount - current.outcome.planned.amount) | money }}</b>
                                </td>
                                <td :class="{'pt-5 value summary summary': true, 'text-danger': (current.income.fact.amount - current.outcome.fact.amount) < 0}">
                                    <b>{{ (current.income.fact.amount - current.outcome.fact.amount) | money }}</b>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <table class="table-borderless future-table">
                        <thead class="moving-head">
                            <tr>
                                <template v-for="(month, index) in future">
                                    <th class="month-name" :key="`future-month-name-${index}`">
                                        {{ month.name }}
                                        <span class="float-right">
                                            <router-link :to="`/budget/${budget.id}/month/${month.date}`"><i class="fas fa-edit"></i></router-link>
                                        </span>
                                    </th>
                                </template>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <template v-for="(month, index) in future">
                                    <td class="value summary" :key="`future-planned-income-value-summary-${index}`">
                                        <b>{{ month.income.planned.amount | money }}</b>
                                    </td>
                                </template>
                            </tr>
                            <tr>
                                <template v-for="(month, index) in future">
                                    <td class="pt-5 value summary" :key="`future-planned-outcome-value-summary-${index}`">
                                        <b>{{ month.outcome.planned.amount | money }}</b>
                                    </td>
                                </template>
                            </tr>
                            <tr :class="`category-hover category-outcome-${category.id}`" v-for="category in categories" :key="`future-outcome-${category.id}`" :data-category-id="category.id">
                                <template v-for="(month, index) in future">
                                    <td class="value" :key="`future-planned-outcome-category-value-${category.id}-${index}`">
                                        <span>{{ getCategoryValue(month.outcome.planned.categories, category.id) | money }}</span>
                                    </td>
                                </template>
                            </tr>
                            <tr>
                                <template v-for="(month, index) in future">
                                    <td class="pt-5 value summary" :key="`future-planned-diff-value-summary-${index}`">
                                        <b>{{ (month.income.planned.amount - month.outcome.planned.amount) | money }}</b>
                                    </td>
                                </template>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { EventBus } from '../../event-bus';

export default {
    props: ['budget'],

    name: "BudgetList",

    data: function() {
        return {
            current: {},
            past: {},
            future: {},

            prevX: null,
        };
    },

    mounted() {
        this.loadCategories();

        this.loadCurrentMonth();
    },

    computed: {
        ...mapGetters(['categories']),

        incomesCategories() {
            return this.categories.filter((category) => category.incomes);
        },

        outcomesCategories() {
            return this.categories.filter((category) => category.expenses);
        }
    },

    beforeDestroy() {
        const movingHead = document.getElementsByClassName('moving-head');

        // movingHead.forEach((head) => {
        //     head.removeEventListener('mousedown');
        // });

        // document.removeEventListener('mouseup');
        // document.removeEventListener('mousemove');
    },

    methods: {
        ...mapActions(['loadCategories']),

        initScripts() {
            const wrap = document.getElementsByClassName('plan-wrap')[0];
            const pastTable = document.getElementsByClassName('past-table')[0];

            if(wrap && pastTable) {
                const tableWidth = pastTable.offsetWidth;

                wrap.scrollLeft = tableWidth + 1 - (140 * 2);
            }

            const movingHead = document.getElementsByClassName('moving-head');

            movingHead.forEach((head) => {
                head.addEventListener('mousedown', () => {
                    head.classList.add('active');
                });
            });

            document.addEventListener('mouseup', () => {
                movingHead.forEach(head => {
                    head.classList.remove('active');
                });
            });

            document.addEventListener('mousemove', event => {
                const hasActive = () => {
                    let result = false;

                    movingHead.forEach((head) => {
                        if(result === false) {
                            result = head.classList.contains('active');
                        }
                    });

                    return result;
                };

                if(hasActive()) {
                    let moveX = 0;

                    if(this.prevX !== null) {
                        moveX = event.clientX - this.prevX;
                    }

                    let movedX = parseInt(wrap.scrollLeft) - parseInt(moveX);

                    this.prevX = event.clientX;

                    wrap.scrollLeft = movedX;
                }
            });

            //

            const categoryHover = document.getElementsByClassName('category-hover');

            categoryHover.forEach((category) => {
                category.addEventListener('mouseenter', () => {
                    document.querySelectorAll(`.category-outcome-${category.getAttribute('data-category-id')}`).forEach((item) => {
                        item.classList.add('hover');
                    });
                });

                category.addEventListener('mouseleave', () => {
                    document.querySelectorAll(`.category-outcome-${category.getAttribute('data-category-id')}`).forEach((item) => {
                        item.classList.remove('hover');
                    });
                });
            });
        },

        loadPastMonths() {
            axios.get(`/budget/${this.budget.id}/list/past`)
                .then(({data}) => {
                    this.past = data.data;

                    this.loadFutureMonths();
                });
        },

        loadCurrentMonth() {
            axios.get(`/budget/${this.budget.id}/list/current`)
                .then(({data}) => {
                    this.current = data.data;

                    this.loadPastMonths();
                });
        },

        loadFutureMonths() {
            axios.get(`/budget/${this.budget.id}/list/future`)
                .then(({data}) => {
                    this.future = data.data;

                    setTimeout(() => {
                        this.initScripts();
                    }, 300);
                });
        },

        getCategoryValue(categories, id) {
            if(categories[id] !== undefined) {
                return categories[id];
            }

            return 0;
        }
    },
}
</script>

<style lang="scss">
.budget-list {
    .empty-item {
        height: 24px;
        display: block;
    }

    table {
        tr {
            td, th {
                width: 140px;
                max-width: 140px;
                min-width: 140px;
            }

            th {
                padding: 5px 5px 5px 10px;
                border-bottom: 1px solid transparent!important;
                border-right: 1px solid transparent!important;
            }

            td {
                border-right: 1px solid #ece9e4!important;
            }

            &.hover {
                td {
                    background: rgba(#000, 0.07);
                }
            }

            .month-name {
                border-color: #ece9e4!important;

                &.current {
                    background: rgba(#000, .1);
                    border-right: 1px solid #ece9e4!important;
                }
            }

            .plan-category {
                padding: 5px 5px 5px 10px;
                white-space: nowrap;
            }

            .value {
                text-align: right;
                padding: 5px 10px 5px 5px;
            }
        }
    }

    .categories-table {
        width: 100%;

        tr {
            td {
                //max-width: 240px;
                border-right: none!important;
            }

            &.hover {
                td {
                    border-top-left-radius: 3px;
                    border-bottom-left-radius: 3px;
                }
            }
        }
    }

    .plan-wrap {
        height: 100%;
        width: 100%;
        overflow-x: auto;
        overflow-y: hidden;
        position: relative;

        table {
            height: 100%;
        }

        .moving-head {
            cursor: grab;
            user-select: none;

            &.active {
                cursor: grabbing;
            }
        }

        .past-table {
            display: inline-block;
            background: rgba(#000, 0.03);

            th {
                border-color: #ece9e4;
            }

            td:nth-child(2n-1) {
                border-color: transparent;
            }
        }

        .data-wrap {
            display: flex;
        }
    }
}
</style>